import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
const AuthRoute = () => {
    const token = useSelector(state => state?.userData?.access_token)
    const brandAccount = useSelector(state => state?.userData?.brandAccount)
    return (
        <>
            {/* {token ? <Outlet /> : <Navigate to="/" />} */}
            {(token && brandAccount?.id) ? <Outlet /> : (token && !brandAccount?.id) ? <Navigate to="/select-business" /> : <Navigate to="/" />}
        </>
    )
}
export default AuthRoute;